"use strict";
var USER_GROUPS = require('./userGroups');
/**
 * @typedef UserGroupSetting
 * @property {string} default_group_name
 * @property {string} role_id
 * @property {string} role_name
 * @property {string} classname
 * @property {string} [type]
 */
/**
 * The default user groups for the system
 * @type {Object<string, Object<string, UserGroupSetting>>}
 */
var DEFAULT_USER_GROUPS = USER_GROUPS;
module.exports = DEFAULT_USER_GROUPS;
